import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../lib/api";

// Fetch goal stats + intelligence policy together for routing callout
export const useGoalPolicy = (goal, options = {}) => {
  return useQuery({
    queryKey: ["goalPolicy", goal],
    queryFn: async () => {
      const [stats, policy] = await Promise.allSettled([
        apiClient.getGoalStats(goal),
        apiClient.getIntelligencePolicy(goal, "balanced"),
      ]);
      return {
        stats: stats.status === "fulfilled" ? stats.value : null,
        policy: policy.status === "fulfilled" ? policy.value : null,
      };
    },
    staleTime: 1000 * 30,
    enabled: !!goal,
    ...options,
  });
};

// Fetch recent outcomes for a goal (has failure_reason)
export const useGoalOutcomes = (goal, limit = 50, options = {}) => {
  return useQuery({
    queryKey: ["goalOutcomes", goal, limit],
    queryFn: () => apiClient.getRecentOutcomes(goal, limit),
    staleTime: 1000 * 15,
    enabled: !!goal,
    ...options,
  });
};

// Fetch span tree for a single trace
export const useSpanTree = (traceId, options = {}) => {
  return useQuery({
    queryKey: ["spanTree", traceId],
    queryFn: () => apiClient.getExecutionTree(traceId),
    staleTime: 1000 * 60 * 5,
    enabled: !!traceId && options.enabled !== false,
    ...options,
  });
};
